<app-layout>
  <app-voltar route="listagem/transportadora" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="Nome da Transportadora"
          name="NM_TPTD"
          formControlName="NM_TPTD"
          placeholder="Digite aqui"
          maxLength="100"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="CNPJ"
          name="TX_CNPJ_TPTD"
          formControlName="TX_CNPJ_TPTD"
          placeholder="__.___.___/____-__"
          mask="00.000.000/0000-00"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Contato"
          name="TX_CNTT_TPTD"
          formControlName="TX_CNTT_TPTD"
          placeholder="Digite aqui"
          mask="(00) 00000-0000"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>
      </div>

      <app-botao
        class="botao-cadastro"
        type="cadastro"
        [text]="modoEditar ? 'Editar' : 'Cadastrar'"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
